import QuipliEditor from 'ckeditor';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { useEffect, useState, useContext } from 'react';
import { TenantContext } from '../../context/tenant-context';

export const TextEditor = ({ initialValue, inputId }: { initialValue?: string; inputId: string }) => {
  const [editorFailed, setEditorFailed] = useState<boolean>(false);
  const [v, setV] = useState<string | undefined>(initialValue);
  const { tenant, contextPath } = useContext(TenantContext);

  useEffect(() => {
    if (v) $(`#${inputId}`).val(v);
  }, [v]);

  useEffect(() => {
    if (editorFailed) {
      setEditorFailed(false);
    }
  }, [editorFailed]);

  return (
    <>
      {!editorFailed && (
        <div id={inputId}>
          <div className="hidden" id="ckeditor-tenant-name">
            {tenant}::{contextPath}
          </div>
          <CKEditor
            editor={QuipliEditor as any}
            data={v}
            onChange={(event, editor) => setV(editor.getData())}
            onError={(e, p) => {
              if (!p.willEditorRestart) {
                setTimeout(() => setEditorFailed(true), 100);
              }
            }}
          />
        </div>
      )}
    </>
  );
};
